import { render, staticRenderFns } from "./DepartureTabsEmail.vue?vue&type=template&id=8a62a09a&scoped=true&"
import script from "./DepartureTabsEmail.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsEmail.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsEmail.vue?vue&type=style&index=0&id=8a62a09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a62a09a",
  null
  
)

export default component.exports